import React, { useRef } from "react";
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function AirlineIngestUploadButton({ onFile, loading = false, children = "航司班期接入" }) {
    const inputRef = useRef(null);

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept=".pdf,application/pdf"
                style={{ display: "none" }}
                onChange={(event) => {
                    const file = event.target.files?.[0];
                    event.target.value = "";
                    if (file) {
                        onFile(file);
                    }
                }}
            />
            <Button type="primary" ghost icon={<UploadOutlined />} loading={loading} onClick={() => inputRef.current?.click()}>
                {children}
            </Button>
        </>
    );
}
